<template>
  <div class="infos">
    <remaining-time></remaining-time>
  </div>
</template>

<script>
import RemainingTime from './RemainingTime'

export default {
  name: 'race-infos',
  components: {
    RemainingTime
  }
}
</script>



// WEBPACK FOOTER //
// Infos.vue?15c29f46